/**
 * api交易类接口
 */
import { post } from '@/utils/http'

// 获取会员列表
export const apiClubCardIndex = p =>
  post('/FitnessClubCard/fClubCardIndex.do', p)

/**
 *  教练管理
 */
// 按照status分页查询全部
export const apiFitnessCoach = p => post('/FitnessCoach/findAll.do', p)
// 编辑or新增or软删除健身教练信息
export const apiAddFitnessCoach = p =>
  post('/FitnessCoach/addFitnessCoach.do', p)
